<div class="container">
  <div class="row">
    <div class="col-3">
      <mat-form-field appearance="outline" >
        <mat-label >Centre Name</mat-label>
        <mat-select  aria-label="Default select example" [(ngModel)]="SelectedCenters" (selectionChange)="onCenterSelectionChange($event)">
          <mat-option  [value]="{centreCode:'All',centreName:'All Centres'}">All</mat-option>
          <mat-option *ngFor="let c of (centres$ | async)" [value]="c">{{c.centreName}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-3">
      <mat-form-field appearance="outline">
        <mat-label>Enter a date range</mat-label>
        <mat-date-range-input [rangePicker]="picker"  required>
          <input matStartDate placeholder="Start date" [(ngModel)]="startDate" >
          <input matEndDate placeholder="End date" [(ngModel)]="endDate">
        </mat-date-range-input>
        <mat-hint>dd/MM/yyyy – dd/MM/yyyy</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    </div>

    <div class="col-3">
      <mat-form-field appearance="outline">
        <mat-label>Submit Type</mat-label>
        <mat-select [(ngModel)]="selectedSubmitType">
          <mat-option value="draft">Draft</mat-option>
          <mat-option value="final">Final</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-3">
      <div class="d-flex gap-3">
        <button mat-mini-fab (click)="filterData()" color="accent">
          <mat-icon>search</mat-icon>
        </button>
        <button mat-mini-fab (click)="clearAll()" color="accent">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="ngxTableHeader">
      <ul class="header-buttons-left ms-0 mb-0">
        <li class="dropdown">
          <h2>Counselling Impact Report</h2>
        </li>
        <li class="dropdown m-l-20">
          <label for="search-input"><i class="material-icons search-icon">search</i></label>
          <input placeholder="Search" id="search-input" type="text" class="browser-default search-field"
                 (keyup)='applyFilter($event)' aria-label="Search box" #input>
        </li>
      </ul>
      <ul class="header-buttons mr-2">
        <li class="me-2">
          <button   mat-mini-fab color="primary"   (click)="addReport()" permission="Counseling Impact Report" [permissionTypes]="[PermissionType.ALL, PermissionType.ADD]" *ngIf="!externalUser">
            <mat-icon class="col-white" >add</mat-icon>
          </button>
        </li>


        <li>
          <button
            mat-mini-fab color="accent"
            (click)="downloadExcel()">
            <mat-icon>download</mat-icon>
          </button>
        </li>
        <!--        <li>-->
        <!--          <div  class="export-button m-l-10" matTooltip="XLSX" (click)="exportexcel()">-->
        <!--            <img src="assets/images/icons/xlsx.png" alt="" />-->
        <!--          </div>-->
        <!--        </li>-->
      </ul>
    </div>

    <table mat-table [dataSource]="dataSource" style="width: 100%" matSort class="body ">
      <!-- Define columns -->
      <ng-container matColumnDef="sr">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Sr </th>
        <td mat-cell *matCellDef="let element;let i =index"> {{ i+1 }} </td>
      </ng-container>
      <ng-container matColumnDef="centreName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Centre </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{ element.centreName }} </td>
      </ng-container>
      <ng-container matColumnDef="individualSessions">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Individual Sessions </th>
        <td mat-cell *matCellDef="let element"> {{ +element.sessionCounts.individualSessions }} </td>
      </ng-container>


      <ng-container matColumnDef="groupSessions">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Group Sessions </th>
        <td mat-cell *matCellDef="let element"> {{ +element.sessionCounts.groupSessions }} </td>
      </ng-container>
      <ng-container matColumnDef="assessmentSessions">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Assessment Sessions </th>
        <td mat-cell *matCellDef="let element"> {{ +element.sessionCounts.assessmentSessions }} </td>
      </ng-container>
      <ng-container matColumnDef="from">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> From </th>
        <td mat-cell *matCellDef="let element"> {{ element.from.toDate() |date:'dd/MM/yyyy' }} </td>
      </ng-container>
      <ng-container matColumnDef="to">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> To </th>
        <td mat-cell *matCellDef="let element"> {{ element.to.toDate()|date:'dd/MM/yyyy'}} </td>
      </ng-container>
      <ng-container matColumnDef="submitType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Submit Type</th>
        <td mat-cell *matCellDef="let element"> {{ (element.submitType)|titlecase }}</td>
      </ng-container>
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
        <td mat-cell *matCellDef="let element"> {{ element.createdAt.toDate()|date:'dd/MM/yyyy' }} </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Actions  </th>
        <td mat-cell *matCellDef="let element" class="truncate-text">
          <button mat-icon-button matTooltip="View"  permission="Counseling Impact Report" [permissionTypes]="[PermissionType.VIEW]"  (click)="ViewReportImpact(element.id)" color="primary"><mat-icon>visibility</mat-icon> </button>
          <button  mat-icon-button matTooltip="Edit"  *ngIf="element.submitType=='draft'" permission="Counseling Impact Report" [permissionTypes]="[PermissionType.ALL,PermissionType.EDIT]" (click)="ViewReport(element.id)" color="primary"><mat-icon>edit</mat-icon> </button>
          <button mat-icon-button matTooltip="Delete" *ngIf="element.submitType=='draft'" permission="Counseling Impact Report" [permissionTypes]="[PermissionType.ALL,PermissionType.ARCHIVE]" (click)="deleteReport(element.id)" color="warn"><mat-icon>delete</mat-icon> </button>
        </td>
      </ng-container>
      <!-- Repeat for other columns -->

      <!-- Render rows -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table><mat-paginator [pageSizeOptions]="[ 25,50 ,100]"></mat-paginator>
    <!-- No Data Message -->
    <ng-container *ngIf="dataSource.data.length === 0">
      <p class="no-data-message">No data matching the filter </p>
    </ng-container>

  </div>

</div>
